function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8205384,18.92 L13.7587238,12.82 C14.8953141,11.46 15.5732802,9.72 15.5732802,7.82 C15.5732802,3.5 12.0837488,0 7.77666999,0 C3.46959123,0 0,3.5 0,7.82 C0,12.14 3.48953141,15.62 7.77666999,15.62 C9.73080758,15.62 11.5254237,14.9 12.8813559,13.7 L18.9431705,19.82 C19.1824526,20.06 19.5812562,20.06 19.8205384,19.82 C20.0598205,19.56 20.0598205,19.18 19.8205384,18.92 Z M7.77667006,14.3800001 C4.16749756,14.3800001 1.23629116,11.4400001 1.23629116,7.82000003 C1.23629116,4.2 4.16749756,1.23999998 7.77667006,1.23999998 C11.4057827,1.23999998 14.3369891,4.18 14.3369891,7.82000003 C14.3369891,11.4600001 11.4057827,14.3800001 7.77667006,14.3800001 Z",
  id: "zoom-icon"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.db2dd601.svg";
export { ForwardRef as ReactComponent };